import React from 'react';
import autoBind from 'react-autobind';
import ProfileLoader from '../../components/ProfileLoader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
  },
  avatar: {
    margin: 3,
  },
  bigAvatar: {
    width: '100px',
    height: '100px',
    backgroundColor: '#d5d5d54a',
  },
  member_name: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: '#843384cf',
  },
  infoContent: {
    wordBreak: 'break-word',
  },
  careerCard: {
    marginTop: theme.spacing.unit * 2 + 4,
    marginRight: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
    marginLeft: theme.spacing.unit * 2 + 4,
  },
  foodies: {
    textAlign: 'center',
    padding: '50px 20px 20px 20px',
    background: '#3d062b',
    color: '#ffff',
    height: '300px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  whiteText: {
    color: 'white',
  },
  contributeButton: {
    background: theme.palette.ternary.dark,
    color: '#ffff',
  },
  container: {
    padding: '10px',
  },
  principleContainer: {
    background: theme.palette.others.bg1,
  },
  memberContainer: {
    paddingBottom: '20px',
  },
  pageTitles: {
    padding: '20px 0 20px 12px',
  },
  expandTitile: {
    padding: '10px 0 20px 21px',
    marginTop: '-31px',
  },
});

const principles = [
  {
    name:
      'I love to discover and be part of food experiences that are delightful. ',
    content: [
      ` > You are here because you love exploring cultures through food.`,
      ` > You are here because you like the thought of being part of a community of foodies sharing their cherished food adventures.`,
    ],
  },
  {
    name: 'My opinion is unbiased as the eatery did not pay for my meal.',
    content: [
      ` > Your views on the eatery or the experience should be independent of any baises that are likely to creep in if the meal is not paid for, or is in lieu of favours.`,
      ` > A meal at a restaurant should be paid for either by you or someone in your group who is independent any influence from the establishment`,
    ],
  },
  {
    name: 'I only recommend restaurants that I have tried and loved.',
    content: [
      `> Tell the community about restaurants that you absolutely love or have been to again and again.`,
      `> This may be only about 20% or even less of the total options available in most cities, but that's okay because we believe in recommending only the most-loved on TS.`,
    ],
  },
  {
    name:
      'Food is a personal experience. I respect other opinions and welcome different perspectives.',
    content: [
      `> Where's the fun without differences in opinion. Enjoy it, respect it`,
      `> Someone disagrees with you? That's their opinion. You have yours.`,
    ],
  },
  {
    name: 'The experiences I share are mine and not borrowed.',
    content: [
      `> Authentic experiences will always stand out and be appreciated.`,
      `> Your words are far better than any you can borrow.`,
      `> Write what you know and not what you think others want to hear.`,
    ],
  },
  {
    name:
      'I recommend foodies whose opinions and independence I personally trust.',
    content: [
      `> Build the Pundit community by bringing together like minded people.`,
      `> Only refer people whom you consider an expert on food and cuisine. We trust your opinion.`,
    ],
  },
];

const communityQues = [
  {
    name: 'How can I help build the community here at TS?',
    content:
      'This is a platform where we bring together beautiful people like you all over the world, who share a similar passion. Know someone who lives on the other side of the country, but is equally obsessed about food? Bring them in so that we have new stories to share, the more the merrier.',
  },
  {
    name: 'Where do I recommend a new pundit?',
    content:
      'Mail us hello@talkingstreet.in, ccing the person you are recommending and why you are recommending them. ',
  },
];
const writingTipsData = [
  {
    name: 'What helps the readers when they are browsing TS?',
    content:
      'One line summary: Helps the reader get context of the article before reading it.',
  },
  {
    name:
      'What are the various points that I should hit when describing the food?',
    content:
      'Bring the food alive with your description of the dish: Describing the food using all your senses will help it come alive for your followers: what you see (thick gravy peppered with peas), hear (sizzling, crackling, boiling etc.), smell (aromatic, flavourful), taste (piquant, tangy, spicy, peppery), mouth-feel (crunchy, melting, firm etc.).',
  },
  {
    name:
      'Do I have to add pictures all the time? Is there a ratio of text and pictures that have to be maintained?',
    content:
      'Images and videos help bring the experience alive in conjunction with the words. (We all love to visualize experiences as well.) Do use them to illustrate your stories.',
  },
  {
    name:
      'Are there things that I should avoid while writing about an eatery or making up a listicle?',
    content:
      'It is best to avoid superlatives while describing the taste of the food. E.g. The taste is to die-for, the dish stopped me in my tracks, mouth-watering tikkis, it tastes divine, it is food invented by Gods in Goa – these are best avoided.',
  },
  {
    name: `What will make my story/listicle more useful to a reader? What information does the reader get on TS that they don't get with on a generic search? `,
    content:
      'Do include useful tips about the eatery. We call these Pundit Tips and these make your article especially helpful for your readers and followers. For example, if a particular place has parking issues, do add a line. Or if there is a particular dish that you especially recommend, please mention it here. Similarly, if a joint has huge crowds after 5PM, you could add a short sentence.',
  },
];
const writingStoryData = [
  {
    name: `Why tell a story when I'm adding an eatery? `,
    content:
      'While we love your information about restaurants, we also want to hear the whole story. An adventure adds to the taste of a dish! Did you perhaps serendipitously stumble upon the restaurant or maybe went searching for it? Or share a series of images as a photo story about a city, eatery or region. Or a video related to food that you would like to share.',
  },
  {
    name: 'What is a story?',
    content:
      'A story is all about your food experiences. Travelled this holiday season, had an adventure that lead to a great meal? Went to the beach and had the best masala peanuts? Even images and videos on their own, with a short explanation, make for great stories. Sharpen your pencils and tell us, or sketch us a picture with photos and videos.',
  },
  {
    name: 'Can I tell a story with just pictures? What about videos?',
    content: `Can't find the words? Polish your skills by telling us the story of your travel, adventures and all the food you had through your camera. Although, do write in a sentence or two to give some context.`,
  },
  {
    name: `Do I have to add an eatery when I'm writing a story?`,
    content: 'Not necessarily, but it will help build our community.',
  },
];
const cutTSData = [
  {
    name: 'Do I write about every place I visit?',
    content: `While we'd love to hear about all your adventures, we are looking specifically for those eateries that you haven't stopped gushing about. The eateries you keep bringing up in random conversations so that you can convince the people around you to go there for the next meal. If it’s only been a week since you tried it out and you’ve already been there twice, we'd want to know about it.`,
  },
  {
    name: `Can I write about the hole in the wall I've been to recently? What about a food truck?`,
    content: `Fine dining? Biryani cart? Hole-in-the-wall? Food Trucks? Street food? We don't discriminate. If you love it, we'd love it.`,
  },
  {
    name: 'How old does an eatery have to be before I can write about it?',
    content: `Eateries that have celebrated their first birthday. As odd as that sounds, we've found that a lot of them pull down their shutters in the first year.`,
  },
  {
    name:
      'Are there other things I have to look out for before I choose to write about the place?',
    content: `They are clean and hygienic (you won't find Gordon Ramsay lurking around in the kitchens yelling at the owner for maintaining a dirty kitchen.)`,
  },
  {
    name: `What about a chain restaurant?`,
    content: `If it’s a chain of restaurants, we'd prefer to hear only about the King, the best of the best, the supreme chain commander.`,
  },
];

const writingEateryData = [
  {
    name: `Why write about an eatery?`,
    content: `What makes an eatery irresistible to us is the story. Every place has a beginning that started as an idea, that shows us how the owners envisioned, how they come about creating this lovely food. Spin us that tale and you'll have our attention always.`,
  },
  {
    name: `What do I write about the eatery?`,
    content: [
      `1. What does the place look like? Is the small, big, rustic, posh, charming, themed?? Paint us a picture with your words, or with an actual picture.`,

      `2. Does the ambience set the mood? Some light music, live music, dim light, bright light, flashy lights? Tell us what we should expect.`,

      `3. Let’s not forget the food! How does it look? Does it make you drool? In what did they serve it? What was that first bite like? Did the flavours explode in your mouth? Let us live vicariously through that adventure of yours.`,
    ],
  },
  {
    name: `What should I write about when I talk about the food?`,
    content: `Describing the food using all your senses will help it come alive for your followers: what you see (thick gravy peppered with peas), hear (sizzling, crackling, boiling etc.), smell (aromatic, flavourful), taste (piquant, tangy, spicy, peppery), mouth-feel (crunchy, melting, firm etc.).`,
  },
  {
    name: `Are there points that I have to look out for when I taste a dish?`,
    content: `Did the food blow your mind away? Tell us more, what about it was outstanding? What did you taste? Sweet, sour, crunchy, umami? Describe it for us.`,
  },
  {
    name: `What are pundit tips?`,
    content: `These are useful tips about the eatery. They make your information especially helpful for your readers and followers. For example, if there is a particular dish that you especially recommend, please mention it here. Similarly, if a joint has huge crowds after 5PM, you could add a short sentence.`,
  },
  {
    name: `How important is it to know the history of the eatery? How about the owners, do I have to talk to them?`,
    content: `If you do get an opportunity to talk to the owners, do! The history of their success always adds another layer of charm to the place. Let them weave their story for you.`,
  },
  {
    name: `What should I take pictures of when writing about an eatery, the restaurant or the food?`,
    content: `Take pictures of everything! The road that led you to the place, the poeple, the environment, the ambience and yes, most importantly, the food!`,
  },
  {
    name: `If I am adding an image, do I still have to describe it?`,
    content: `While a photo would give us a wonderful perspective of what the place is all about, we'd still want to know what you think about it. Your opinion matters!`,
  },
];
const makingAlistData = [
  {
    name: `What will my list contain?`,
    content: [
      ` a. Your lists could be just the names of places with a small summary of what you liked there, or tips for visitors`,
      ` b. It could also just be pictures of different meals that we should try.`,
      ` c. You could try making a list each time you explore a new city/town.`,
      ` d. Or even tell us all about your city/town. e. It could even be a list of restaurants that allow pets!
            The permutations are endless, so have fun with it!`,
    ],
  },
  {
    name: `How can I theme my lists? `,
    content: `Collate your eateries into fun and funky lists based on any category you choose, like locations, cuisines, date night, or even apology dinners.`,
  },
  {
    name: `Do I have to add an eatery before adding it to a list?`,
    content: `If it's not already on Talking Street, you would need to start by adding it as an eatery first. Then you could select it when you create your list. This helps us ensure that the readers get all the additional information such as address and images from the database.`,
  },
  {
    name: `Do I need to write anything about the eatery, when I add it to a list?`,
    content: `One line or more about why you are including the eatery as part of the listicle. Another thing that makes listicles intersting are special pundit tips that you can add about the eatery.`,
  },
];
const imageAddingTips = [
  {
    name: 'Tell me all about sourcing and crediting images',
    content: `Sourcing and credits: Do make a note of the source of the image and add it in the Image credit section.`,
  },
  {
    name: `If I am selecting pictures off the internet, what are the things that I need to look out for? What kind of images should I find on the internet, if I don't have one of my own?`,
    content: [
      `Selecting images off the net:`,

      `a. Pick images that bring the dish you are mentioning alive in the context that it is being mentioned. Ideally try to find images that are of the dish in the specific outlet you are writing about.`,

      `b. Look for well composed close-ups of the dishes.`,
    ],
  },
  {
    name:
      'What about the size of the image? Does it matter? What about the dimensions?',
    content: `Size of Image: Make sure that your photos are about 2-3 MB in size (set your DSLR settings to M) so that they can be comfortably reduced to a size of 125 KB before uploading. The images that go up on the site have to be this size to ensure that the site functions smoothly. Very heavy images will make the site slow and very light images will pixelate when a user zooms in (especially for the menu images).`,
  },
  {
    name:
      'Do I need to take a photo of the surroundings and environment of the eatery?',
    content: `Setting context: Do share at least one shot of the location to set context. If you are writing about Delhi, find an image that brings alive what you are describing. If it is Chandni Chowk, pick an image that shows the streets, the red fort perhaps, a set of outlets etc. If it is about Park Street in Kolkata, similarly, pick an image that sets context.`,
  },
  {
    name: 'Do you have some photo taking tips?',
    content: [
      `For those who are particular about their images, here are some Pundit Tips on how to get great images:`,
      ` 1. Do use a camera for the photographs unless you have a brilliant phone camera. It is difficult to match the colours, clarity and overall quality of a DSLR image.`,
      ` 2. Take ""Shallow Depth of Field"" photographs. Do research and read up on Shallow Depth of Field. Food photographs are best when they are taken as close-up photos with a part of the food in focus and the rest of it out of focus.`,
      ` 3. If you are using a point and shoot camera, you could use it in macro mode, or close-up mode, or food photo mode or flower photography mode.`,
      ` 4. If you are using a DSLR, you would need to use it in Aperture mode with the Aperture setting at the lowest ""f"" reading.`,
      ` 5. It is best not to apply any effects or filters on the photographs. Natural images of food, real looking photographs without any effects usually look the best.`,
      ` 6. Light plays a huge role in getting good photographs. Try and take the photos in natural light as far as possible i.e. before sun down. Photos using light from a tube or a bulb will rarely be as good. Flash photography is best avoided.`,
      ` 7. Take photos of food just when it is served / ready to be served. Avoid photographs of food that has been bitten into or eaten. They are usually not appetizing.`,
    ],
  },
];
const funData = [
  {
    name: `I'd love to learn and make contributions better. Do you recommend any reading material on food writing and photography?`,
    content: [
      `Some online Food Photography resources to get you started:`,

      `Food Photography Basics - http://www.crumblycookie.net/food-photography/`,

      `Street Food Photography Tips - http://www.picturecorrect.com/tips/street-food-photography-tips/`,
    ],
  },
];

const writtenData = {
  writingEateryData,
  communityQues,
  writingTipsData,
  cutTSData,
  makingAlistData,
  writingStoryData,
  funData,
  imageAddingTips,
};

const Principle = ({ number, name, content, classes }) => {
  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body1">
          <b>
            Principle #{number}: {name}
          </b>
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.principleContainer}>
        <div>
          {typeof content === 'object' ? (
            content.map((sub, id) => {
              return (
                <Typography variant="body1" key={id}>
                  {sub}
                </Typography>
              );
            })
          ) : (
            <Typography variant="body1">{content}</Typography>
          )}
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

class Principle2 extends React.Component {
  state = {
    newExpand: false,
  };
  indiviual = () => {
    this.setState({ newExpand: !this.state.newExpand });
  };

  componentWillReceiveProps(newProps) {
    this.setState({ newExpand: newProps.expanded });
  }

  render() {
    let { name, content, classes } = this.props;
    return (
      <ExpansionPanel
        expanded={this.state.newExpand}
        onClick={() => this.indiviual()}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">
            <b>{name}</b>
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.principleContainer}>
          <div>
            {typeof content === 'object' ? (
              content.map((sub, id) => {
                return (
                  <Typography variant="body1" key={id}>
                    {sub}
                  </Typography>
                );
              })
            ) : (
              <Typography variant="body1">{content}</Typography>
            )}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

class ContributorGuidlines extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      sectionList: [
        {
          text: 'What makes the cut on TS?',
          varKey: 'cutTSData',
        },
        {
          text: '  Writing about an eatery',
          varKey: 'writingEateryData',
        },
        {
          text: '    Making a list',
          varKey: 'makingAlistData',
        },
        {
          text: ' Writing a story',
          varKey: 'writingStoryData',
        },
        {
          text: '  Some writing tips',
          varKey: 'writingTipsData',
        },
        {
          text: 'Image adding steps and tips',
          varKey: 'imageAddingTips',
        },
        {
          text: 'Some fun reads to get you excited',
          varKey: 'funData',
        },
        {
          text: ' Building the community',
          varKey: 'communityQues',
        },
      ],
      expanded: false,
      sectionExpanded: {},
    };
  }
  expandAllPanel = key => {
    let sectionExpanded = this.state.sectionExpanded;
    sectionExpanded[key] = true;
    this.setState({ sectionExpanded });
  };
  collaspAll = key => {
    let sectionExpanded = this.state.sectionExpanded;
    sectionExpanded[key] = false;
    this.setState({ sectionExpanded });
  };
  render() {
    const { classes, loading } = this.props;
    if (loading) {
      return (
        <ProfileLoader loadingText="Please wait... Contributor Guidelines getting ready!! " />
      );
    } else {
      return (
        <div>
          <div className={classes.foodies}>
            <Typography
              className={classes.whiteText}
              variant="h5"
              component="h5"
            >
              Why are you here?
            </Typography>
            <br />
            <Typography variant="body1" className={classes.whiteText}>
              <i>
                You are our pandits, our gurus, of food and cuisine. We, and our
                readers, trust your opinion and are waiting on the edge of our
                seats to hear what you have to say.
              </i>
            </Typography>
          </div>
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <Typography className={classes.pageTitles} variant="h6">
                Our Manifesto
              </Typography>
            </Grid>
          </Grid>
          <div>
            {principles.map((principle, i) => (
              <Principle
                classes={classes}
                key={'principle' + i}
                number={i + 1}
                name={principle.name}
                content={principle.content}
              />
            ))}
          </div>

          {this.state.sectionList.map((ele, i) => {
            return (
              <div key={'ele' + i}>
                <Grid container className={classes.container}>
                  <Grid item xs={12}>
                    <Typography className={classes.pageTitles} variant="h6">
                      {ele.text}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container className={classes.expandTitile} spacing={16}>
                  <Grid item>
                    <Typography
                      component="p"
                      onClick={() => this.expandAllPanel(ele.varKey)}
                    >
                      Expand All
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography component="p">|</Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      component="p"
                      onClick={() => this.collaspAll(ele.varKey)}
                    >
                      Collapse all
                    </Typography>
                  </Grid>
                </Grid>
                <div>
                  {writtenData[ele.varKey].map((principle, i) => (
                    <Principle2
                      classes={classes}
                      key={ele.varKey + i}
                      number={i + 1}
                      name={principle.name}
                      content={principle.content}
                      expanded={this.state.sectionExpanded[ele.varKey] || false}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  }
}

export default withStyles(styles)(ContributorGuidlines);
